import { inject, Injectable, Provider } from '@angular/core';
import { ShortlistMergePrompt } from '@rma/public/compare-agent/private-api/da-compare-agent';
import { RmaModalService } from '@rma/public/generic/ui/modal';
import { from, Observable, switchMap } from 'rxjs';
import type { ShortlistMergeModalData } from './shortlist-merge.facade';
import type { ShortlistMergeModalComponent } from './ui-shortlist-merge-modal/shortlist-merge-modal.component';

@Injectable()
export class ShortlistMergePromptService implements ShortlistMergePrompt {
  private readonly modalService = inject(RmaModalService);

  public choose(localCodes: string[], apiCodes: string[]): Observable<string[] | undefined> {
    return from(import('./ui-shortlist-merge-modal/shortlist-merge-modal.component')).pipe(
      switchMap(({ ShortlistMergeModalComponent: component }) =>
        this.modalService
          .open<ShortlistMergeModalComponent, ShortlistMergeModalData, string[] | undefined>(component, {
            data: { localCodes, apiCodes },
            disableClose: true,
            maxWidth: '72rem',
            width: 'calc(100vw - 2rem)',
            ariaLabelledBy: 'rma-shortlist-merge-heading',
            autoFocus: 'dialog',
          })
          .afterClosed(),
      ),
    );
  }
}

export const provideShortlistMergePrompt = (): Provider => ({ provide: ShortlistMergePrompt, useClass: ShortlistMergePromptService });
